export default __webpack_public_path__ + "static/media/img-0618-monaco-half-face.fa015b77.png";